import React from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";

const InstalledCard = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Paper
        elevation={2}
        sx={{
          p: 2,
          textAlign: "left",
          height: 300,
          width: 320,
          mx: "auto",
        }}
      >
        <Grid container direction="column">
          <Grid item sx={{ mt: 0.5, textAlign: "center" }}>
            <VolunteerActivismIcon
              sx={{
                color: "#1c355e",
                width: 200,
                height: 200,
                opacity: 0.1,
              }}
            />
            <Typography
              sx={{
                textAlign: "center",
                zIndex: 10,
                fontSize: 20,
                mt: -22,
              }}
            >
              {t("steps.installedMessage")}
            </Typography>
          </Grid>

          <Grid container justifyContent="center" mt={4}>
            <Grid>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                component="a"
                href={process.env.CP_URL}
              >
                {t("steps.myAccount")}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

export default InstalledCard;
